module.exports = __webpack_public_path__ + "static/media/21n.7b19124e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/21n.svg
// module id = 168
// module chunks = 0